/**
 * Head of Organisation helpers for RM validation.
 */

export function getHeadOfOrganisationEmployeeId(companyLike) {
  if (!companyLike) return null;
  const raw =
    companyLike.headOfOrganisationEmployeeId ??
    companyLike.head_of_organisation_employee_id ??
    null;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function isHeadOfOrganisationEmployee(employeeId, companyLike) {
  const hoId = getHeadOfOrganisationEmployeeId(companyLike);
  if (hoId == null || employeeId == null || employeeId === "") return false;
  return Number(employeeId) === hoId;
}
